import React, { useEffect, useRef } from "react";
import './styles.css';
import '../styles.css';
const ScreenShareViewVideo = (props) => {
    const { selfVideo, peers, consumers } = props;
    const selfRef = useRef(null);
    const peerRefs = {};
    // const totalVideos = peers.length + (selfVideo ? 1 : 0);
    useEffect(() => {
        if (selfRef && selfRef.current && selfVideo) {
            selfRef.current.srcObject = selfVideo;
        }
    }, [selfVideo, selfRef]);
    useEffect(() => {
        if (consumers && consumers.length > 0) {
            consumers.forEach(consumer => {
                if (consumer.kind === "video" && consumer.source === "webcam" && peerRefs[consumer.peerId]) {
                    const stream = new MediaStream();
                    stream.addTrack(consumer.track);
                    peerRefs[consumer.peerId].srcObject = stream;
                }
            });
        }
    }, [consumers]);
    return (
        <div className="screenShareViewContainer">
            <div  className="screenViewBox">
                <div id={'self'}  className="screenViewVideoBox">
                    <div id={`img-self_id`} className={!selfVideo ? "zIndexPositive" : "profileImg"}>
                        <img src="/images/icons/profile-outline.png" alt="avtar"/>
                    </div>
                    <div className="screenConfNameBox">
                        <small>You</small>
                    </div>
                    {selfVideo && <video ref={selfRef} className="videoElm" autoPlay playsInline controls={false} muted />}
                </div>
            </div>
            {peers.map((peer, i) => (
                <div key={peer.id}  className="screenViewBox">
                    <div id={peer.id} className="screenViewVideoBox">
                        {consumers.filter((each) => each.peerId === peer.id && each.kind === 'video').length === 0 &&
                            <div id={`img-${peer.id}`} className="videoDisableAvatar">
                                <img src="/images/icons/profile-outline.png" alt="avtar"/>
                            </div>
                        }
                        <div className="screenConfNameBox">
                            <small>{peer.displayName}</small>
                        </div>
                        <video className={consumers.filter((each) => each.peerId === peer.id && each.kind === 'video').length === 0 && "zIndexNegative"}
                            key={peer.id} ref={node => { peerRefs[peer.id] = node; }} id={peer.id} muted playsInline autoPlay />
                    </div>
                </div>
            ))}
        </div>
    );
};
export default ScreenShareViewVideo;

